import { Badge } from "@/components/ui/badge";

const MAP = {
  UNSCHEDULED: { label: "Belum Terjadwal", cls: "bg-amber-50 text-amber-700 border-amber-200/70", dot: "bg-amber-500" },
  SCHEDULED: { label: "Terjadwal", cls: "bg-sky-50 text-sky-700 border-sky-200/70", dot: "bg-sky-500" },
  PAID: { label: "Lunas", cls: "bg-emerald-50 text-emerald-700 border-emerald-200/70", dot: "bg-emerald-500" },
  active: { label: "Aktif", cls: "bg-sky-50 text-sky-700 border-sky-200/70", dot: "bg-sky-500" },
  settled: { label: "Lunas", cls: "bg-emerald-50 text-emerald-700 border-emerald-200/70", dot: "bg-emerald-500" },
  superseded: { label: "Digantikan", cls: "bg-slate-100 text-slate-500 border-slate-200/70", dot: "bg-slate-400" },
  pending: { label: "Menunggu", cls: "bg-amber-50 text-amber-700 border-amber-200/70", dot: "bg-amber-500" },
  approved: { label: "Disetujui", cls: "bg-emerald-50 text-emerald-700 border-emerald-200/70", dot: "bg-emerald-500" },
  rejected: { label: "Ditolak", cls: "bg-rose-50 text-rose-700 border-rose-200/70", dot: "bg-rose-500" },
};

export function StatusBadge({ status, testid }) {
  const m = MAP[status] || { label: status, cls: "bg-slate-100 text-slate-600 border-slate-200/70", dot: "bg-slate-400" };
  return (
    <Badge data-testid={testid} variant="outline" className={`gap-1.5 font-semibold ${m.cls}`}>
      <span className={`h-1.5 w-1.5 rounded-full ${m.dot}`} />
      {m.label}
    </Badge>
  );
}

export function RescheduleBadge() {
  return (
    <Badge variant="outline" className="gap-1.5 bg-purple-50 text-purple-700 border-purple-200/70 font-semibold ml-1">
      <span className="h-1.5 w-1.5 rounded-full bg-purple-500" />
      Reschedule
    </Badge>
  );
}
